module.exports = "<Checkbox\n  name=\"checkboxName1\"\n  value=\"checkboxValue1\"\n  label=\"went for a run today\"/>\n\n<Checkbox\n  name=\"checkboxName2\"\n  value=\"checkboxValue2\"\n  label=\"fed the dog\"\n  defaultChecked={true}/>\n\n<Checkbox\n  name=\"checkboxName3\"\n  value=\"checkboxValue3\"\n  label=\"built a house on the moon\"\n  disabled={true}/>\n\n<Checkbox\n  name=\"checkboxName4\"\n  value=\"checkboxValue4\"\n  checkedIcon={<ToggleStar />}\n  unCheckedIcon={<ToggleStarBorder />}\n  label=\"custom icon\" />\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/checkbox-code.txt
 ** module id = 855
 ** module chunks = 0
 **/